var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition, } from "@atlaskit/modal-dialog";
import { AiFillStar } from "react-icons/ai";
import { BiSearchAlt } from "react-icons/bi";
import { IoIosClose } from "react-icons/io";
import { Checkbox } from "@atlaskit/checkbox";
import { IconFavorites } from '../../../../base/icons/svg';
import Button from "@atlaskit/button/standard-button";
import NestedSelect from "./NestedSelect";
const InstitutionMemberSearchModal = ({ isOpen, closeModal }) => {
    const { t } = useTranslation();
    const [searchTermName, setSearchTermName] = useState("");
    const [onlyFavorites, setOnlyFavorites] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [searchTriggered, setSearchTriggered] = useState(false);
    const [selectedInstitutionUsers, setSelectedInstitutionUsers] = useState([]);
    const [selectedPartners, setSelectedPartners] = useState([]);
    const [prevSelectedInstUsers, setPrevSelectedInstUsers] = useState([]);
    const [prevSelectedPartners, setPrevSelectedPartners] = useState([]);
    const [institutionUsers, setInstitutionUsers] = useState([]);
    const [queryParameters, setQueryParameters] = useState({
        office: "",
        department: "",
        position: "",
    });
    //=======================================================================================================================================================
    const toggleFavorite = (isPartner, userId) => {
        fetch(`/livi/api/preuser/institution/favorites/${userId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                isPartner: isPartner,
            }),
        })
            .then((res) => {
            if (res.ok) {
                setOnlyFavorites(false);
                setInstitutionUsers((prevUsers) => {
                    return prevUsers.map((user) => {
                        if (user.id === userId) {
                            return Object.assign(Object.assign({}, user), { isFavorites: !user.isFavorites });
                        }
                        return user;
                    });
                });
                console.log("User Marked as Favorite!", res.status);
            }
            else if (res.status === 405) {
                console.log("Method not allowed, error code is: ", res.status);
                alert(t("addPeople.actionIsNotAllowed"));
            }
            else if (res.status > 299 || res.status < 500) {
                console.log("Failed to mark user as Favorite!", res.status);
                alert(t("addPeople.markAsFavoriteFail"));
            }
            else {
                console.log("Network or Server error occurred, error code is: ", res.status);
                alert(t("addPeople.serverError"));
            }
        })
            .catch((error) => {
            console.log("Something went wrong, error: !", error);
            alert(t("addPeople.somethingWentWrong"));
        });
    };
    //=======================================================================================================================================================
    const shareLink = () => {
        fetch("/livi/api/preuser/institution/invitation", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                institutionUsers: selectedInstitutionUsers,
                partners: selectedPartners,
            }),
        })
            .then((res) => {
            if (res.status === 200) {
                const responseText = res.text();
                console.log("Response text:", responseText);
                closeModal();
                alert(t("addPeople.successSharingMeetingLink"));
            }
            else if (res.status === 401) {
                console.log("Unauthorized action, error code is: ", res.status);
                alert(t("addPeople.notAuthorized"));
            }
            else if (res.status === 403) {
                console.log("Forbidden action!, error code is: ", res.status);
                alert(t("addPeople.forbiddenAction"));
            }
            else if (res.status > 499) {
                console.log("Network or Server error, error code is: ", res.status);
                alert(t("addPeople.serverError"));
            }
            else {
                console.log("Failed to post", res.status);
                alert(t("addPeople.failSharingMeetingLink"));
            }
        })
            .catch((error) => {
            console.log(error);
            alert(t("addPeople.somethingWentWrong"));
        });
    };
    //=======================================================================================================================================================
    const handleQueryParameters = (updatedQueryParameters) => {
        setQueryParameters(updatedQueryParameters);
    };
    //=======================================================================================================================================================
    const handleUnselect = (category) => {
        setQueryParameters((prevQueryParameters) => (Object.assign(Object.assign({}, prevQueryParameters), { [category]: "" })));
    };
    //=======================================================================================================================================================
    useEffect(() => {
        const getInstitutionMemberInfo = () => __awaiter(void 0, void 0, void 0, function* () {
            let params = {};
            const searchTerms = [
                { term: queryParameters.office, key: "office" },
                { term: queryParameters.department, key: "department" },
                { term: queryParameters.position, key: "position" },
                { term: searchTermName, key: "name" },
            ];
            const searchParams = searchTerms.reduce((acc, { term, key }) => {
                if (term !== "") {
                    return Object.assign(Object.assign({}, acc), { [key]: term });
                }
                return acc;
            }, {});
            params = Object.assign(Object.assign({}, params), searchParams);
            let query = "?" + Object.keys(params)
                .map((k) => encodeURIComponent(k) + "=" + params[k])
                .join("&");
            console.log("this is query", '/livi/api/preuser/institution' + query);
            fetch(`/livi/api/preuser/institution${query}`, {
                credentials: 'include',
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then((res) => {
                if (res.status === 200) {
                    res.json().then((data) => __awaiter(void 0, void 0, void 0, function* () {
                        setInstitutionUsers(data);
                    }));
                }
                else {
                    console.log("Failed to fetch:", res.status);
                }
            });
        });
        //=======================================================================================================================================================
        const getFavorites = () => {
            fetch(`/livi/api/preuser/institution/favorites`, {
                credentials: 'include',
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then((res) => {
                if (res.status === 200) {
                    res.json().then((data) => __awaiter(void 0, void 0, void 0, function* () {
                        setInstitutionUsers(data);
                    }));
                }
                else {
                    console.log("Failed to fetch:", res.status);
                }
            });
        };
        if (onlyFavorites) {
            getFavorites();
        }
        else {
            getInstitutionMemberInfo();
        }
    }, [selectedPartners, selectedInstitutionUsers, queryParameters, onlyFavorites, searchTriggered]);
    return (React.createElement(ModalTransition, null, isOpen && (React.createElement(Modal, { onClose: closeModal, width: "large" },
        React.createElement(ModalHeader, null,
            React.createElement(ModalTitle, { className: "modal-title" }, t("addPeople.institutionMembers"))),
        React.createElement(ModalBody, { className: "link-share-modal-body" },
            React.createElement("div", { className: "search-field" },
                React.createElement(NestedSelect, { selectOptionsOpen: false, queryParameters: queryParameters, onQueryParametersChange: handleQueryParameters }),
                React.createElement("div", { className: "text-field-cover" },
                    React.createElement(BiSearchAlt, { className: "search-icon", onClick: () => setSearchTriggered(!searchTriggered) }),
                    React.createElement("input", { className: "input", autoComplete: "off", placeholder: t("addPeople.searchInstitutionMember"), onChange: (event) => {
                            if (event.target.value === "") {
                                setSearchTriggered(!searchTriggered);
                            }
                            setSearchTermName(event.target.value);
                        }, onKeyDown: (event) => {
                            if (event.key === "Enter") {
                                event.preventDefault();
                                event.stopPropagation();
                                setSearchTriggered(!searchTriggered);
                            }
                        } }),
                    React.createElement("div", { className: `favorites-button ${onlyFavorites ? "selected" : ""}`, onClick: () => setOnlyFavorites(!onlyFavorites) },
                        React.createElement(IconFavorites, { className: "favorites-icon", alt: "" })))),
            React.createElement("div", { className: "additional-options" },
                React.createElement("div", { className: "selected-items-container" },
                    queryParameters.office && React.createElement("div", { className: "selectedItemsContainerDiv" },
                        queryParameters.office,
                        " ",
                        React.createElement(IoIosClose, { className: "selectedItemsContainerDivSvg", onClick: () => handleUnselect("office") })),
                    queryParameters.department && React.createElement("div", { className: "selectedItemsContainerDiv" },
                        queryParameters.department,
                        " ",
                        React.createElement(IoIosClose, { className: "selectedItemsContainerDivSvg", onClick: () => handleUnselect("department") })),
                    queryParameters.position && React.createElement("div", { className: "selectedItemsContainerDiv" },
                        queryParameters.position,
                        " ",
                        React.createElement(IoIosClose, { className: "selectedItemsContainerDivSvg", onClick: () => handleUnselect("position") })))),
            React.createElement("div", { className: "table-container" },
                React.createElement("div", { className: "table-wrapper" },
                    React.createElement("table", { className: "institution-table" },
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", { className: "table-header first" },
                                    React.createElement(Checkbox, { onChange: (event) => {
                                            const isAllSelected = event.target.checked;
                                            if (isAllSelected) {
                                                setPrevSelectedInstUsers(selectedInstitutionUsers);
                                                setPrevSelectedPartners(selectedPartners);
                                                setIsAllChecked(true);
                                                institutionUsers.forEach((user) => {
                                                    if (user.isInstitutionUser) {
                                                        if (!selectedInstitutionUsers.includes(user.id)) {
                                                            setSelectedInstitutionUsers((prevUsers) => [...prevUsers, user.id]);
                                                        }
                                                    }
                                                    else {
                                                        if (!selectedPartners.includes(user.id)) {
                                                            setSelectedPartners((prevUsers) => [...prevUsers, user.id]);
                                                        }
                                                    }
                                                });
                                            }
                                            else {
                                                setSelectedInstitutionUsers(prevSelectedInstUsers);
                                                setSelectedPartners(prevSelectedPartners);
                                                setIsAllChecked(false);
                                            }
                                        }, value: "Medium checkbox", name: "checkbox-basic", size: "medium" }),
                                    t("addPeople.all")),
                                React.createElement("th", { className: "table-header" }, t("addPeople.username")),
                                React.createElement("th", { className: "table-header" }, t("addPeople.office")),
                                React.createElement("th", { className: "table-header" }, t("addPeople.department")),
                                React.createElement("th", { className: "table-header" }, t("addPeople.position")),
                                React.createElement("th", { className: "table-header last" }, t("addPeople.favorite")))),
                        React.createElement("tbody", null, institutionUsers.map((user) => (React.createElement("tr", { key: user.id },
                            console.log("==========", user.id),
                            React.createElement("td", { className: "table-cell first" },
                                React.createElement(Checkbox, { isChecked: isAllChecked ? isAllChecked : undefined, onChange: (event) => {
                                        const isChecked = event.target.checked;
                                        if (user.isInstitutionUser) {
                                            if (isChecked) {
                                                setSelectedInstitutionUsers((prevUsers) => [...prevUsers, user.id]);
                                            }
                                            else {
                                                setSelectedInstitutionUsers((prevUsers) => prevUsers.filter((userId) => userId !== user.id));
                                            }
                                        }
                                        else {
                                            if (isChecked) {
                                                setSelectedPartners((prevUsers) => [...prevUsers, user.id]);
                                            }
                                            else {
                                                setSelectedPartners((prevUsers) => prevUsers.filter((userId) => userId !== user.id));
                                            }
                                        }
                                    }, value: "Medium checkbox", name: "checkbox-basic", size: "medium" })),
                            React.createElement("td", { className: "table-cell" }, user.nickname),
                            React.createElement("td", { className: "table-cell" }, user.office),
                            React.createElement("td", { className: "table-cell" }, user.department),
                            React.createElement("td", { className: "table-cell" }, user.position),
                            React.createElement("td", { className: "table-cell last" },
                                React.createElement(AiFillStar, { onClick: () => toggleFavorite(user.isPartnerUser, user.id), className: `star-icon${user.isFavorites ? " favorite" : ""}` })))))))))),
        React.createElement(ModalFooter, { className: "footer-styles" },
            React.createElement(Button, { appearance: "danger", onClick: closeModal, className: "footer-button" }, t("addPeople.cancel")),
            React.createElement(Button, { onClick: shareLink, className: "footer-button send" }, t("addPeople.sendLink")))))));
};
export default InstitutionMemberSearchModal;
